import { callApi } from 'utils/api';
import { ctTokenModel } from 'common/api/models';

/**
 * @param {string} SSOToken - KeyCloak `token` store.authentication.token
 * @return {Promise<ctTokenModel>}
 */
export const fetchCtTokenApi = (SSOToken) => callApi(`login`, `POST`, { SSOToken }, false).then(ctTokenModel);
